<template>
  <v-container fluid class="manage-price-channels-page">
    <PriceChannels />
  </v-container>
</template>

<script>
import PriceChannels from "@/components/settings/price-channels.vue";

export default {
  name: "ManagePriceChannelsPage",
  components: {
    PriceChannels,
  },
};
</script>
